import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-update-old-prompt",
	templateUrl: "./update-old-prompt.component.html",
	styleUrls: ["./update-old-prompt.component.css"],
})
export class UpdateOldPromptComponent implements OnInit {
	constructor(public ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	///////////////////////////////
	// Buttons
	///////////////////////////////
	onYes() {
		this.ref.close(1);
	}

	onNo() {
		this.ref.close(0);
	}

	onCancel() {
		this.ref.close(-1);
	}

	///////////////////////////////
}
